import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from '../input'
import {textInput} from '@cred/react-form-field'
import config from 'config'
import {Testable} from '@cred/react-testable'
import styles from './styles.module.scss'
import 'isomorphic-fetch'

const SEARCH_PLACEHOLDER = 'Type to start finding schools'

class SchoolSearch extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
  }

  static defaultProps = {
    autoFocus: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      results: null,
      searching: false,
      active: 0,
      refs: [],
      keys: ''
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.onClick = this.onClick.bind(this)
    this.fieldAssignment = this.fieldAssignment.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.handleOutsideClick)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    const dropdownElement = this.component

    if (event.target !== dropdownElement && !dropdownElement.contains(event.target)) {
      this.setState({results: null})
    }
  }

  render() {
    const results = this.state.results,
      {autoFocus, className, name, label, validate } = this.props

    let searchResults = ''

    /* If 'results' is null, the search is inactive and we don't show the results list. */
    if (results && results.length > 0) {
      const schoolList = results.map(({institution_name, school_key}, index) => {
        return <li key={`result-${school_key}`} onMouseOver={e => this.handleMouseOver(e, index)} className={this.state.active == index + 1 ? styles.active : ''} onClick={this.onClick(results[index])}>
          <div className={styles.result}>
            {this.highlightKeywords(institution_name, this.state.keys)}
          </div>
        </li>
      }, this)

      searchResults = <Testable testId="search-results" className={styles.schoolList}>
          <ul>{schoolList}</ul>
        </Testable>
    }

    return (
      <div className={[styles.search, className].join(' ')} ref={component => this.component = component}>
        <Input
          autoFocus={autoFocus}
          name={name}
          autoComplete="off"
          placeholder={SEARCH_PLACEHOLDER}
          label={label}
          type="search"
          ref={this.fieldAssignment}
          onChange={this.handleSearchChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onKeyDown={this.handleKeyDown}
          component={textInput}
          validate={validate}
        />
        {searchResults}
      </div>
    )
  }

  fieldAssignment(field) {
    this.field = field
  }

  onClick(school) {
    return e => {
      if (this.props.onSelectSchool) {
        this.props.onSelectSchool(school)
      }

      this.setState({results: null})
      e.preventDefault()
    }
  }

  highlightKeywords(schoolName, keyword) {
    let highlighted = <span className={styles.schoolName} dangerouslySetInnerHTML={{__html: schoolName}}/>

    if (schoolName && keyword) {
      const keywordLength = keyword.trim().length,
        start = schoolName.toUpperCase().indexOf(keyword.trim().toUpperCase())

      if (start >= 0) {
        highlighted = <span className={styles.schoolName}>
          <span dangerouslySetInnerHTML={{__html: schoolName.substr(0, start)}}/>
          <span className={styles.keyword}>{schoolName.substr(start, keywordLength)}</span>
          <span dangerouslySetInnerHTML={{__html: schoolName.substr(start + keywordLength, schoolName.length - (start + keywordLength))}}/>
        </span>
      }
    }

    return highlighted
  }

  handleFocus() {
    this.startSearch(this.state.keys)

    this.field.placeholder = ''
  }

  handleBlur(e) {
    this.field.placeholder = SEARCH_PLACEHOLDER
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }

  handleMouseOver(e, index) {
    this.setState({active: index + 1})
  }

  handleKeyDown(e) {
    let active = this.state.active

    switch (e.key) {
      case 'ArrowUp':
        if (active > 0) {
          active--
          this.setState({active})
        }
        e.preventDefault()
        break
      case 'ArrowDown':
        if (this.state.results && active < this.state.results.length) {
          active++
          this.setState({active})
        }
        e.preventDefault()
        break
      case 'Tab':
        if (this.props.onSelectSchool && this.state.results && this.state.results[active - 1]) {
          this.props.onSelectSchool(this.state.results[active - 1])
        }

        this.setState({results: null})
        break
      case 'Enter':
        if (this.props.onSelectSchool && this.state.results) {
          this.props.onSelectSchool(this.state.results[active - 1])
          e.preventDefault()
          this.setState({results: null})
        }
        break
    }
  }

  handleSearchChange(e, keys) {
    if (keys.length > 2) {
      this.setState({active: 0})
      this.startSearch(keys)
    } else {
      this.setState({results: null, keys: ''})
    }
  }

  startSearch(keys) {
    if (!this.state.searching) {
      if (keys.length > 2) {
        this.setState({searching: true, keys})

        return fetch(`${config.searchSchoolsBaseUrl}${config.searchSchoolsEndpointUrl}?q=${encodeURIComponent(keys)}&_=${Date.now()}`)
          .then(res => res.json())
          .then(r => {
            const results = r.slice(0, 5)

            results.push({institution_name: 'Other - school not listed', school_key: ''})
            this.setState({
              results,
              searching: false
            })

            if (this.state.nextSearch) {
              this.startSearch(this.state.nextSearch)
              this.setState({nextSearch: ''})
            }
          })
          .catch(() => this.setState({searching: false}))
      }
    } else {
      this.setState({nextSearch: keys, keys})
    }
  }
}

export {SchoolSearch}
